import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from '@/services/utils/day';
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const pdfPrinter = () => {
    const { formatToDdMmYy } = useDate();
    const { getHeader } = pdfHeaderFooter();

    const exportToPDF = (company, reportList, date, specifications) => {

        var doc = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [ 30, 100, 30, 60 ],
            header: getHeader(company),
            content: getContent(reportList, date, specifications),

            styles : {
                header: {
                    fontSize: 24
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
            },
            info: {
                title: 'OPD Bill Report'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (reportList, date, specifications) => {
        return [
            {
                text: 'OPD Bill Report',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },

            {
                stack: [
                    {
                        text: `Date: ${formatToDdMmYy(date.start_date)} To ${formatToDdMmYy(date.end_date)}`
                    }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    headerRows: 2,
                    widths: getTableWidths(specifications),
                    body: getTableBody(reportList, specifications)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex < 2) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getSpecificationList = (specifications) => {
        if (! specifications) return []
        return Object.keys(specifications).map((key) => {
            return { key: key, label: specifications[key] }
        })
    }

    const getTableWidths = (specifications) => {
        const specWidths = getSpecificationList(specifications).flatMap(() => ['auto', 'auto']);
        return ['auto', '*', ...specWidths, 'auto', 'auto']
    }

    const getTableBody = (reportList, specifications) => {
        const specificationList = getSpecificationList(specifications);
        const header = getTableHead(specificationList);
        const row = getTableRow(reportList, specificationList);
        return [
            ...header,
            ...row
        ]
    }

    const getTableRow = (reportList, specificationList) => {
        const data = [];
        reportList.map((child, index) => {
            const specCells = specificationList.flatMap((spec) => [
                { text: child[spec.key + '_count'], alignment: 'right' },
                { text: formatAmount(child[spec.key + '_amount']), alignment: 'right' }
            ]);
            const row = [
                { text: index + 1 },
                { text: child.consultant_name },
                ...specCells,
                { text: child.total_count, alignment: 'right' },
                { text: formatAmount(child.total_amount), alignment: 'right' }
            ];
            data.push(row);
        })
        const specTotals = specificationList.flatMap((spec) => [
            { text: columnSum(reportList, spec.key + '_count'), alignment: 'right' },
            { text: formatAmount(columnSum(reportList, spec.key + '_amount')), alignment: 'right' }
        ]);
        const totalRow = [
            { text: 'Total', colSpan: 2, alignment: 'right' },
            { text: '' },
            ...specTotals,
            { text: columnSum(reportList, 'total_count'), alignment: 'right' },
            { text: formatAmount(columnSum(reportList, 'total_amount')), alignment: 'right' },
        ];

        data.push(totalRow);
        return data
    }

    const columnSum = (data, field) => {
        return data.reduce((sum, child) => sum + Number(child[field]), 0)
    }

    const formatAmount = (amount) => {
        return Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }

    const getTableHead = (specificationList) => {
        const groupCells = specificationList.flatMap((spec) => [
            { text: spec.label.toUpperCase(), colSpan: 2, alignment: 'center' },
            { text: '' }
        ]);
        const subCells = specificationList.flatMap(() => [
            { text: 'COUNT', alignment: 'right' },
            { text: 'AMOUNT', alignment: 'right' }
        ]);
        return [
            [
                { text: 'SL', rowSpan: 2 },
                { text: 'NAME OF CONSULTANT', rowSpan: 2 },
                ...groupCells,
                { text: 'TOTAL', colSpan: 2, alignment: 'center' },
                { text: '' }
            ],
            [
                { text: '' },
                { text: '' },
                ...subCells,
                { text: 'COUNT', alignment: 'right' },
                { text: 'AMOUNT', alignment: 'right' }
            ]
        ]
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
